import { Box, SxProps } from '@mui/material';
import { FC } from 'react';

export interface LabeledTextProps {
  label: string;
  sx?: SxProps;
  children?: React.ReactNode;
}

export const LabeledText: FC<LabeledTextProps> = (props) => {
  const { label, sx, children } = props;

  return (
    <Box sx={{ marginTop: '10px', ...sx }}>
      <Box sx={{ color: '#7D7D7D', fontSize: '12px', lineHeight: '160%' }}>{label}</Box>
      <Box sx={{ marginTop: '2px', lineHeight: '140%', letterSpacing: '0.15px', fontSize: '14px' }}>{children}</Box>
    </Box>
  );
};
